import React, { FC } from "react";
import Dropdown from "../../../../../ui/widgets/dropdown";
import { useMessageSource } from "react-message-source";
import { FilterProductRefType } from "../index";
import {
  DropdownMenuItemProps,
  DropdownProps,
} from "../../../../../ui/widgets/dropdown/types";
import { ProductFamily } from "../../../../../context/product-context/product-family";
import { Product } from "../../../../../context/product-context/product";

interface FilterByProductProps {
  onSelect: DropdownProps["onSelect"];
  initialValue: FilterProductRefType;
  filterByFamily: ProductFamily;
  defaultFilterValue: DropdownMenuItemProps;
}

const FilterByProduct: FC<FilterByProductProps> = ({
  onSelect,
  initialValue,
  filterByFamily,
  defaultFilterValue,
}: FilterByProductProps): React.JSX.Element => {
  const { getMessage } = useMessageSource();

  const filterValues = [
    defaultFilterValue,
    ...filterByFamily.products.map((product: Product) => {
      return {
        value: product.productRef,
        children: getMessage(
          `Dashboard.cardholderApplication.filter-${product.productRef}`,
        ),
      };
    }),
  ];

  return (
    <Dropdown
      label={getMessage(
        "Dashboard.cardholderApplication.table-filter-product-type",
      )}
      menuItems={filterValues}
      onSelect={onSelect}
      selectedItemValue={initialValue}
    />
  );
};

export default FilterByProduct;
